<template>
  <div class="error-insufficient-container">
    <img src="@/assets/icon/error.png" />
    <div class="content">
      <div v-if="errMessage">{{ errMessage }}</div>
      <div v-else><span>Error: </span>Insufficient fund!</div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['errMessage'],
  components: {},
  methods: {}
};
</script>

<style lang="scss" scoped>
.error-insufficient-container {
  width: 370px;
  min-height: 160px;
  padding: 0px 15px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  flex-direction: column;
  .content {
    width: 100%;
    text-align: center;
    color: #354165;
    span {
      color: #d3180c;
      font-family: Inter-Bold;
    }
  }
}
</style>
